// @ts-nocheck
(function () {
  function init() {
    document.querySelectorAll('form[data-company-id]').forEach(initKlaviyoForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  let phoneLibPromise = null;
  function loadPhoneLib() {
    if (window.libphonenumber && window.libphonenumber.parsePhoneNumberFromString) {
      return Promise.resolve();
    }
    if (phoneLibPromise) return phoneLibPromise;
    phoneLibPromise = new Promise(function (resolve, reject) {
      const existing = document.querySelector('script[data-phone-lib]');
      if (existing) {
        existing.addEventListener('load', resolve);
        existing.addEventListener('error', reject);
        return;
      }
      const s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/libphonenumber-js@1.10.53/bundle/libphonenumber-max.js';
      s.async = true;
      s.defer = true;
      s.setAttribute('data-phone-lib', '1');
      s.onload = resolve;
      s.onerror = function () {
        reject(new Error('Failed to load libphonenumber-js'));
      };
      document.head.appendChild(s);
    });
    return phoneLibPromise;
  }

  function initKlaviyoForm(form) {
    const emailInput = form.querySelector('input[type="email"], input[name="email"]');
    const phoneInput = form.querySelector('input[type="tel"], input[name="phone_number"]');
    const countrySelect = form.querySelector('[data-country-select]');
    const statusEl = form.querySelector('[data-status]');
    const defaultCountry = form.dataset.phoneCountry || '+1';
    const successText = form.dataset.successMessage || 'Thanks for contacting us.';
    const errorText = form.dataset.errorMessage || 'Something went wrong. Please try again.';

    const countryEntries = (form.dataset.countriesRaw || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean)
      .map(function (entry) {
        const parts = entry.split(':').map(function (p) { return p.trim(); });
        const name = parts[0] || '';
        const code = parts[1] || '';
        let min = null;
        let max = null;
        if (parts[2]) {
          if (parts[2].indexOf('-') !== -1) {
            const mm = parts[2].split('-');
            min = parseInt(mm[0], 10);
            max = parseInt(mm[1], 10);
          } else {
            min = parseInt(parts[2], 10);
            max = min;
          }
        }
        return { name: name, code: code, min: min, max: max };
      });

    function findCountryMeta(dial) {
      for (let i = 0; i < countryEntries.length; i++) {
        if (countryEntries[i].code === dial) return countryEntries[i];
      }
      return null;
    }

    function setStatus(type, msg) {
      if (!statusEl) return;
      statusEl.textContent = msg || '';
      statusEl.className = 'contact-lifeline__status' + (type ? ' is-' + type : '');
    }

    async function handleSubmit(e) {
      if (e) e.preventDefault();
      if (!emailInput) return;

      const honeypot = form.querySelector('input[name="_hp"]');
      if (honeypot && honeypot.value) return;

      const email = (emailInput.value || '').trim();
      const rawPhone = phoneInput ? (phoneInput.value || '').trim() : '';
      const nameVal = (form.querySelector('input[name="name"]') || {}).value;
      const subjectVal = (form.querySelector('[name="subject"]') || {}).value;
      const bodyVal = (form.querySelector('[name="body"]') || {}).value;
      const name = (nameVal || '').trim();
      const subject = (subjectVal || '').trim();
      const message = (bodyVal || '').trim();
      let formattedPhone = '';

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setStatus('error', 'Please enter a valid email address');
        return;
      }

      if (rawPhone) {
        let baseCode = ((countrySelect && countrySelect.value) || defaultCountry).replace(/[^+\d]/g, '');
        if (baseCode.charAt(0) !== '+') baseCode = '+' + baseCode;
        const digits = rawPhone.replace(/[^0-9]/g, '');
        const meta = findCountryMeta(baseCode);
        const minLen = meta && meta.min ? meta.min : 7;
        const maxLen = meta && meta.max ? meta.max : 14;

        if (digits.length < minLen || digits.length > maxLen) {
          const lenMsg = meta && meta.min === meta.max
            ? String(meta.min)
            : minLen + '-' + maxLen;
          setStatus('error', 'Invalid phone length. Expected ' + lenMsg + ' digits');
          return;
        }

        const candidate = baseCode + digits;
        if (!/^\+[1-9]\d{7,14}$/.test(candidate)) {
          setStatus('error', 'Invalid international format');
          return;
        }

        try {
          await loadPhoneLib();
          const parseFn = window.libphonenumber && window.libphonenumber.parsePhoneNumberFromString;
          if (parseFn) {
            const parsed = parseFn(candidate);
            if (!parsed || !parsed.isValid()) {
              setStatus('error', 'Phone number not valid for selected country');
              return;
            }
            formattedPhone = parsed.number;
          } else {
            formattedPhone = candidate;
          }
        } catch (_) {
          formattedPhone = candidate;
        }
      }

      const companyId = (form.dataset.companyId || '').trim();
      const listId = (form.dataset.listId || '').trim();
      const revision = (form.dataset.revision || '').trim() || '2024-10-15';
      const source = form.dataset.source || 'Contact Lifeline Form';
      const eventName = form.dataset.eventName || 'Submitted Contact Form';
      const internalEmail = (form.dataset.internalEmail || '').trim();
      const smsSource = form.dataset.smsSource || source;

      if (!companyId || !listId) {
        setStatus('error', 'Form not configured');
        return;
      }

      setStatus('loading', 'Sending...');

      const profileAttrs = { email: email };
      if (formattedPhone) profileAttrs.phone_number = formattedPhone;
      if (name) profileAttrs.first_name = name;
      profileAttrs.properties = {
        sms_consent: !!formattedPhone,
        sms_consent_timestamp: new Date().toISOString(),
        sms_consent_source: smsSource,
      };

      const subscribePayload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: { data: { type: 'profile', attributes: profileAttrs } },
          },
          relationships: { list: { data: { type: 'list', id: listId } } },
        },
      };

      const eventProfileAttrs = internalEmail
        ? { email: internalEmail }
        : (formattedPhone
            ? { email: email, phone_number: formattedPhone }
            : { email: email });

      const eventPayload = {
        data: {
          type: 'event',
          attributes: {
            properties: {
              name: name,
              email: email,
              phone_number: formattedPhone,
              subject: subject,
              message: message,
              source: source,
            },
            metric: {
              data: { type: 'metric', attributes: { name: eventName } },
            },
            profile: {
              data: { type: 'profile', attributes: eventProfileAttrs },
            },
          },
        },
      };

      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        revision: revision,
      };
      const qs = '?company_id=' + encodeURIComponent(companyId);

      const subscribePromise = fetch('https://a.klaviyo.com/client/subscriptions/' + qs, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(subscribePayload),
      });
      const eventPromise = fetch('https://a.klaviyo.com/client/events/' + qs, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(eventPayload),
      });

      const results = await Promise.allSettled([subscribePromise, eventPromise]);
      const subResult = results[0];
      const evResult = results[1];

      const evOk = evResult.status === 'fulfilled' && evResult.value.ok;
      const subOk = subResult.status === 'fulfilled' && subResult.value.ok;

      if (!evOk) {
        let detail = '';
        if (evResult.status === 'fulfilled') {
          try {
            const json = await evResult.value.json();
            detail = json && json.errors && json.errors[0] && json.errors[0].detail;
          } catch (_) {}
        }
        setStatus('error', detail || errorText);
        return;
      }

      if (!subOk) {
        // eslint-disable-next-line no-console
        console.warn('[contact-lifeline] Subscribe call failed but event call succeeded.', subResult);
      }

      setStatus('success', successText);
      form.reset();
      setTimeout(function () { setStatus('', ''); }, 10000);
    }

    form.addEventListener('submit', handleSubmit);

    if (form.id) {
      const externalBtn = document.querySelector('[data-submit-for="' + form.id + '"]');
      if (externalBtn) externalBtn.addEventListener('click', handleSubmit);
    }
  }
})();
